import { ChangeEvent, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useMatch } from "react-router-dom";
import { PREFERRED_ENTITIES_TAG } from "catalog/utils/buildFilterMatrix";
import Switch from "~/components/Switch";

const PreferredSwitch = () => {
  const { setValue } = useFormContext();
  const [ctags, ttags] = useWatch({ name: ["ctags", "ttags"] });
  const match = useMatch("/catalog/:tab/*");
  const tab = match?.params.tab;

  const isChecked = useMemo(() => {
    if (tab === "columns") {
      return ctags.includes(PREFERRED_ENTITIES_TAG);
    }
    if (tab === "tables") {
      return ttags.includes(PREFERRED_ENTITIES_TAG);
    }
    // Pinned page
    return ctags.includes(PREFERRED_ENTITIES_TAG) || ttags.includes(PREFERRED_ENTITIES_TAG);
  }, [tab, ttags, ctags]);

  const updateTags = (value: string, tags: string[], shouldAdd: boolean): string[] => {
    return shouldAdd ? [...tags, value] : tags.filter((tag) => tag !== value);
  };

  return (
    <Switch
      checked={isChecked}
      value={PREFERRED_ENTITIES_TAG}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        const { checked, value } = e.target;
        if (tab === "columns") {
          setValue("ctags", updateTags(value, ctags, checked));
        } else if (tab === "tables") {
          setValue("ttags", updateTags(value, ttags, checked));
        } else {
          setValue("ctags", updateTags(value, ctags, checked));
          setValue("ttags", updateTags(value, ttags, checked));
        }
      }}
    />
  );
};

export default PreferredSwitch;
